<template>
  <div class="card">
      <div class="card-body">
        <h4 class="card-title mb-50 d-flexsss">
          <span>Two-steps verification</span>&nbsp;
          <span v-if="two_step_factor" class="badge bg-light-success">Enabled</span>
          <span v-else class="badge bg-light-warning">Disabled</span>
        </h4>
        <span>Keep your account secure with authentication step.</span>
        <h6 class="fw-bolder mt-2">SMS</h6>
        <!-- <div class="d-flex justify-content-between border-bottom mb-1 pb-1">

        </div> -->
        <!-- <h6 class="fw-bolder mt-2">email</h6> -->
        <div class="d-flex justify-content-between border-bottom mb-1 pb-1">
          <span v-if="data.phone !=null">{{data.phone}}</span>
          <span v-else>Please add your phone number in the edit user update section.</span>
          <!-- <span>{{data.email}}</span> -->
          <div class="action-icons">
            <a href="javascript:void(0)" class="text-body d-flex align-items-center" data-target="#twoFactorAuthModal" data-toggle="modal" v-if="!two_step_factor">
              <vue-feather type='toggle-left' icon class="text-warning"></vue-feather>&nbsp; <span class="text-warning font-weight-bold">Disabled</span>
            </a>
            <a href="javascript:void(0)" class="text-body d-flex align-items-center" v-on:click="showDisableTwoAuth"  v-else> <!--data-target="#twoFactorAuthModal" data-toggle="modal"-->
              <vue-feather type='toggle-right' icon class="text-success"></vue-feather>&nbsp; <span class="text-success font-weight-bold">Enabled</span>
            </a>
            <a href="javascript:void(0)" hidden id="openTwoFactorAuthSmsModalOtp" data-target="#twoFactorAuthSmsModalOtp" data-toggle="modal">clicker</a>
            <a href="javascript:void(0)" hidden id="openTwoFactorAuthSmsPhoneModal" data-target="#twoFactorAuthSmsPhoneModal" data-toggle="modal">closeClicker</a>
          </div>
        </div>
        <p class="mb-4">
          Two-factor authentication adds an additional layer of security to your account by requiring more than just a
          password to log in.
          <a href="javascript:void(0);" class="text-body">Learn more.</a>
        </p>
      </div>
    </div>

    <div class="modal fade" id="twoFactorAuthModal" tabinvdex="-1" aria-labelledby="twoFactorAuthTitle" style="display: none;" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-md two-factor-auth">
        <div class="modal-content">
          <div class="modal-header bg-transparent">
            <button id="twoFactorAuthModalClose" type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          </div>
          <div class="modal-body pb-5 px-sm-5 mx-50">
            <h3 class="text-center mb-1" id="twoFactorAuthTitle">Select Authentication Method</h3>
            <p class="text-center mb-3">
              Please select the option below.
            </p>

            <div class="custom-options-checkable">
              <input class="custom-option-item-check" type="radio" name="twoFactorAuthRadio" :value="1" id="twoFactorAuthSms" v-on:click="set_auth_type(1)">
              <label for="twoFactorAuthSms" class="custom-option-item d-flex align-items-center flex-column flex-sm-row px-3 py-2">
                <span><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-message-square font-large-2 me-sm-2 mb-2 mb-sm-0 mr-2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg></span>
                <span>
                  <span class="custom-option-item-title h3">SMS</span>
                  <span class="d-block mt-75">We will send a code via SMS if you need to use your backup login method.</span>
                </span>
              </label>
            </div>
            <!-- select email -->
            <!-- <div class="custom-options-checkable">
              <input class="custom-option-item-check" type="radio" name="twoFactorAuthRadio" :value="2" id="twoFactorAuthEmail" v-on:click="set_auth_type(2)">
              <label for="twoFactorAuthEmail" class="custom-option-item d-flex align-items-center flex-column flex-sm-row px-3 py-2">
                <span><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-message-square font-large-2 me-sm-2 mb-2 mb-sm-0 mr-2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg></span>
                <span>
                  <span class="custom-option-item-title h3">Email</span>
                  <span class="d-block mt-75">We will send a code to your email address to verify your account.</span>
                </span>
              </label>
            </div> -->

            <button id="nextStepAuth" class="btn btn-primary float-end mt-3 waves-effect waves-float waves-light" v-on:click="requestOtpCode">
              <span class="me-50">Continue</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </button>
          </div>
        </div>
      </div>
      </div>

    <div class="modal fade" id="twoFactorAuthSmsModalOtp" tabindex="-1" aria-labelledby="twoFactorAuthSmsTitle" style="display: none;" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-md two-factor-auth-sms">
        <div class="modal-content">
          <div class="modal-header bg-transparent">
            <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          </div>
          <div class="modal-body pb-5 px-sm-5 mx-50">
            <h4>Verify Your Mobile Number for SMS</h4>
            <p class="card-text mb-75">
              Hey {{user.name?user.name:'there!'}}!
              We sent a verification code to your mobile. Enter the code from the mobile in the field below.
            </p>
            <form class="mt-2" v-on:submit.prevent="verifyOtpCode">
              <h6>Type your 6 digit security code</h6>
              <div class="auth-input-wrapper d-flex align-items-center justify-content-between">
                <input type="text" class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
                  maxlength="1" autofocus="" v-model="input_1"/>

                <input class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
                  maxlength="1" type="text"  v-model="input_2"/>

                <input type="text" class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
                  maxlength="1"  v-model="input_3"/>

                <input type="text" class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
                  maxlength="1"  v-model="input_4"/>

                <input type="text" class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
                  maxlength="1"  v-model="input_5"/>

                <input type="text" class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
                  maxlength="1"  v-model="input_6"/>
              </div>
              <div>
                <p class="text-danger" v-if="error != ''" >{{error}}</p>
              </div>
              <button type="submit" class="btn btn-primary w-100" tabindex="4">Verify</button>
            </form>
            <p class="text-center mt-2" > <!--v-if="auth_type == 1"-->
              <span>Didn’t get the code?</span><a href="#" v-on:click ="resendCode($event,1)"><span>&nbsp;Resend</span></a>
              <!-- <p>OR</p>
              <span>Didn’t get the code?</span><a href="#" v-on:click ="resendCode($event,2)"><span>&nbsp;Resend to Email</span></a> -->
            </p>
            <!-- <p class="text-center mt-2" v-else>
              <span>Didn’t get the code?</span><a href="#" v-on:click ="resendCode($event,2)"><span>&nbsp;Resend Email</span></a>
            </p> -->
            <p class="text-center mt-2">
              <span class="text-success" v-if="resend_res">{{resend_res}}</span> <!--<span v-if="time_left > 0">Time left : {{time_left}}</span>-->
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="swal2-container swal2-center swal2-backdrop-show" style="overflow-y: auto;" v-if="turn_of_two_step">
      <div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-icon-warning swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">
        <div class="swal2-header">
          <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
            <div class="swal2-icon-content">!</div>
          </div>
          <h2 class="swal2-title" id="swal2-title" style="display: flex;">Are you sure?</h2>
          <button type="button" class="swal2-close" aria-label="Close this dialog" style="display: none;">×</button>
        </div>
        <div class="swal2-content">
          <div class="swal2-validation-message" id="swal2-validation-message"></div>
        </div>
        <div class="swal2-actions">
          <div class="swal2-loader"></div>
          <button type="button" class="swal2-confirm btn btn-primary" aria-label="" style="display: inline-block;" v-on:click="disbleShowOption">Yes, disable!</button>
          <button type="button" class="swal2-cancel btn btn-outline-danger ml-1" aria-label="" style="display: inline-block;" v-on:click="showDisableTwoAuth">Cancel</button>
        </div>
        <div class="swal2-timer-progress-bar-container">
          <div class="swal2-timer-progress-bar" style="display: none;"></div>
        </div>
      </div>
    </div>
</template>
<script>
  export default{
    name:'UserTwoStepsVerification',
    components:{
    },
    props: {
      data: {
        type: Object,
        default: () => {},
      },
    },
    data(){
      return{
        user:{},
        input_1:'',
        input_2:'',
        input_3:'',
        input_4:'',
        input_5:'',
        input_6:'',
        sms_auth:'',
        auth_type:1,
        error:'',
        resend_res:false,
        two_step_factor:false,
        turn_of_two_step:false,
        time_left:0,
      }
    },
    created(){

    },
    mounted(){
      this.authenticationfield();
      this.showEnableTwoStep();
    },
    methods:{
      showEnableTwoStep(){
        var status ={
          'status':0
        }
        axios.post(`${baseUrl}/otp/user/check`,status).then(({data})=>{
          this.two_step_factor = data.data.auth_status;
        }).catch((e)=>{
          toastr.error('An Error Occured please try again!','Two Step Verification');
        });
      },
      verifyOtpCode(e){
        e.preventDefault();
        let h = this;
        this.otpcode = `${h.input_1}${h.input_2}${h.input_3}${h.input_4}${h.input_5}${h.input_6}`;
        var otpcode = this.otpcode,route='',verified=false;
        var token = {
          'token':otpcode,
          'toggleOtp': true
        }
        if(this.checkIfNotEmpty(otpcode) && this.add_phone !== ""){
          axios.post(`${baseUrl}/otp/verify`,token).then(({data})=>{
            if(data.message == 'success message'){
              this.cancelMobileModel()
              toastr.success(data.data,'Two Step Verification');
              setTimeout(()=>{
                window.location.reload()
              },1000)
            }else{
              toastr.error(data.data,'Two Step Verification');
            }
          }).catch((e)=>{
            console.log(e.message);
            toastr.error('An Error Occured please try agains!','Two Step Verification');
          });
        }else{
          //  Two Steps Verification
          const numeralMask = document.querySelectorAll('.numeral-mask');
          if (numeralMask.length) {
            numeralMask.forEach(e => {
              if(h.checkIfNotEmpty(e.value)){
                e.classList.add('isValid')
                this.error = ''
              }else{
                e.classList.add('isInvalid')
                this.error = 'All fields must be filled'
              }
            });
          }
        }
      },
      authenticationfield(){
        var inputContainer = document.querySelector('.auth-input-wrapper');
        // Get focus on next element after max-length reach
        inputContainer.onkeyup = function (e) {
          var target = e.srcElement;
          var maxLength = parseInt(target.attributes['maxlength'].value, 10);
          var currentLength = target.value.length;

          if (e.keyCode === 8) {
            if (currentLength === 0) {
              var next = target;
              while ((next = next.previousElementSibling)) {
                if (next == null) break;
                if (next.tagName.toLowerCase() == 'input') {
                  next.focus();
                  break;
                }
              }
            }
          } else {
            if (currentLength >= maxLength) {
              var next = target;
              while ((next = next.nextElementSibling)) {
                if (next == null) break;
                if (next.tagName.toLowerCase() == 'input') {
                  next.focus();
                  break;
                }
              }
            }
          }
        };
      },
      checkIfNotEmpty(val){
        this.error = ''
        if((val !=="" || val !==null ) && typeof Number(val) && val.length == 6){
          return true;
        }else{
          return false;
        }
      },
      resendCode(e,val){
        e.preventDefault();
        let status = {
          'status':0,
          'auth_type':val
        }
        // if(this.time_left !== 0){
        //   return toastr.error('Please wait for the timer to finish its count.','Two Step Verification');
        // }
        axios.post(`${baseUrl}/otp/user/resend`,status).then(({data})=>{
          // this.limitRequest()
          return toastr.success(`${data.data}`,'Two Step Verification');

        }).catch((e)=>{
          if(e.response.status == 429){
            return toastr.error(`${e.response.statusText}, please try agian after 1 minute.`,'Two Step Verification');
          }
          return toastr.error(`${e.response.statusText}`,'Two Step Verification');
        })
      },
      nextStepAuth(){
        if(this.checkAuthTypeSms(this.sms_auth) || (this.auth_type !== "" && typeof this.auth_type == 'number')){
          var openTwoFactorAuthSmsModalOtp = document.getElementById('openTwoFactorAuthSmsModalOtp');
          var twoFactorAuthModalClose = document.getElementById('twoFactorAuthModalClose');
          openTwoFactorAuthSmsModalOtp.click();
          twoFactorAuthModalClose.click()
        };
      },
      requestOtpCode(){
        let status = {
          'status':0,
          'option':this.two_step_factor?'disable':'enable',
          'auth_type':this.auth_type
        }
        // if(this.time_left !== 0){
        //   return toastr.error('Please wait for the timer to finish its count.','Two Step Verification');
        // }
        axios.post(`${baseUrl}/otp/user/send`,status).then(({data})=>{
          // this.limitRequest();
          if(data.error == true){
            return toastr.error('Please check if you have added your phone number and try again.','Two Step Verification');
          }
          this.nextStepAuth();
          toastr.success(data.data,'Two Step Verifications');
        }).catch((e)=>{
          if(e.response.status == 429){
            return toastr.error(`${e.response.statusText}, please try agian after 1 minute.`,'Two Step Verification');
          }
          return toastr.error(`${e.response.statusText}`,'Two Step Verification');
        });
      },
      disbleShowOption(){
        this.requestOtpCode();
        this.gotToNext();
        this.showDisableTwoAuth();
      },
      gotToNext(){
        var twoFactorAuthSmsModalOtp = document.getElementById('twoFactorAuthSmsModalOtp');
        twoFactorAuthSmsModalOtp.style.display = 'block';
        twoFactorAuthSmsModalOtp.setAttribute('role','dialog');
        twoFactorAuthSmsModalOtp.classList.add('show')
      },
      cancelMobileModel(){
        var twoFactorAuthSmsModalOtp = document.getElementById('twoFactorAuthSmsModalOtp');
        var modal_backdrop = document.getElementsByClassName('modal-backdrop');
        modal_backdrop.forEach(e=>{
          e.remove();
        })
        // modal_backdrop = modal_backdrop.classList.remove('show');
        twoFactorAuthSmsModalOtp.style.display = 'none';
        twoFactorAuthSmsModalOtp.removeAttribute('role','dialog');
        twoFactorAuthSmsModalOtp.classList.remove('show');
      },
      checkAuthTypeSms(authType){
        if(authType == "sms-auth"){
          return true;
        }
        return false;
      },
      showDisableTwoAuth(){
        this.turn_of_two_step = this.turn_of_two_step == true?false:true;
      },
      limitRequest(){
        let time_left = 60;
        let request_code = setInterval(()=>{
          time_left --;
          if(time_left < 0){
            clearInterval(request_code)
          }else{
            if(time_left > 10 || time_left == 0){
              time_left = time_left
            }else{
              time_left = '0'+time_left
            }
            this.time_left = parseInt(time_left);
          }
        },1000);
      },
      set_auth_type(val){
        this.auth_type = val;
      }
    }
  }
</script>
